import React from 'react';
import Typography from '@mui/material/Typography';
import Logo from './Logo';
import styles from './BrandHeader.module.css';
import type { Brand } from '../../types/Brand';

interface Props {
  loading: boolean;
  brand: Brand;
}

function Header(props: Props) {
  if (props.loading) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Typography variant="h2">Parts for use with {props.brand.name} Equipment</Typography>
      <Logo brand={props.brand} />
    </div>
  );
}

export default Header;
